import { useMutation } from "@tanstack/react-query";
import fetchApi from "../fetchApi";
import { config } from "../../config";

const apiHost = config.REACT_APP_PROXY_BASE_URL;

export const useDownloadReceiptMutation = ({
  authorisation = "",
  itemId,
}: {
  itemId: string;
  authorisation: string;
}) => {
  return useMutation(
    async () => {
      const res = await fetch(`${apiHost}/payment/pay/${itemId}/receipt`, {
        headers: {
          Authorization: `Bearer ${authorisation}`,
        },
      });

      if (!res.ok) {
        throw new Error("Error when downloading the receipt");
      }

      const blob = await res.blob();
      return blob;
    },
    {
      onSuccess: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `receipt-${itemId}.pdf`; // nom du fichier
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      },
      onError: (error: any) => {
        console.error("Erreur lors du téléchargement du reçu", error);
      },
    }
  );
};
